import { useNewAptitudeTestScoreQuery } from 'components/dashboard/quiz/newAptitude/NewAptitudeQuizSlice';
import Loading from 'components/global/layout/Loading';
import React from 'react';
import SkillReportPDF from './SkillReportPDF';
import { useDomainTestScoreQuery } from 'components/dashboard/quiz/domain/DomainQuizSlice';

const SkillReportData = ({ batchData }: any) => {
  const { isLoading, isSuccess, data } = useNewAptitudeTestScoreQuery();

  const userDetail = batchData.users[0];

  const userData = {
    email: userDetail?.email,
    firstName: userDetail?.name,
    domain: userDetail?.area?.title || '',
  };

  const projectData = batchData.projects.filter((el: any) => {
    return el.projectId?.type === 'Company Tasks';
  })[0]?.projectId;

  const { data: domainData } = useDomainTestScoreQuery();

  return (
    <div>
      {isLoading && <Loading />}
      {isSuccess && data?.testType === 'GSAP' ? (
        <SkillReportPDF
          skillScores={data.gsapRetting}
          projectData={projectData}
          userData={userData}
          domainData={domainData}
        />
      ) : (
        <div>No Score Found</div>
      )}
    </div>
  );
};

export default SkillReportData;
